export const predefinedRuleTags: string[] = ['hipaa', 'audit', 'access', 'endpoint_threat', 'network_threat', 'threat'];
